import React from 'react';
import { Link } from 'react-router-dom';
import { importAll } from '../../utils/images';

const images = importAll(require.context('./assets', false, /\.(png|jpe?g|svg)$/));

class ReportThumb extends React.Component {
    render(){
        return (
            <div className="col-sm-6 col-md-4 col-lg-3 my-3 report-thumb-container">
            <Link to={'/category/' + this.props.categoryId + '/report/' + this.props.report.id }>
                    <div className="report-thumb text-center p-4">
                        
                        <div className="mb-2">
                            <img src={ images[this.props.report.thumbnail] } alt="" />
                        </div>

                        <div className="report-title">
                            { this.props.report.title }
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
}

export default ReportThumb;


// WEBPACK FOOTER //
// ./src/components/reports/ReportThumb.jsx